import {createApp} from "vue";
import App from "../../../vue/ResourceFinder/ResourceFinder.vue";


import Component from "../../base/Component";

export default class ResourceFinder extends Component {
    constructor(props) {
        super(props)
    }

    init() {
        const app = createApp(App)
        app.mount('resource-finder')
    }
}
